import { useState } from "react";
import { Box } from "@chakra-ui/react";

type BaseUnfoldProps = {
  activator: (props: {
    folded: boolean;
    onClick: () => void;
  }) => React.ReactNode;
};
const BaseUnfold: React.FC<BaseUnfoldProps> = ({ children, activator }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      {activator({
        folded: !isOpen,
        onClick: () => {
          setIsOpen(!isOpen);
        },
      })}
      <Box
        h="auto"
        transition={"all 500ms"}
        maxH={isOpen ? "100vh" : "0"}
        overflow="hidden"
      >
        {children}
      </Box>
    </div>
  );
};

export { BaseUnfold };
